import { render, staticRenderFns } from "./Main-edit-conference.vue?vue&type=template&id=c8c297c2&"
import script from "./Main-edit-conference.vue?vue&type=script&lang=js&"
export * from "./Main-edit-conference.vue?vue&type=script&lang=js&"
import style0 from "./Main-edit-conference.vue?vue&type=style&index=0&id=c8c297c2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports